// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_List from "../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as AdjustFareAssetsManager from "../../../assets/AdjustFareAssetsManager.bs.js";

var deleteIcon = AdjustFareAssetsManager.getImage("delete-icon.svg");

function ViewIncidentalCharges$Card(Props) {
  var currency_symbol = Props.currency_symbol;
  var incident_type = Props.incident_type;
  var amount = Props.amount;
  var id = Props.id;
  var deleteClickHandler = Props.deleteClickHandler;
  return React.createElement("div", {
              className: "c-incidental-charge-card-wrapper"
            }, React.createElement("div", {
                  className: "incidental-charge-card-header"
                }, React.createElement("p", {
                      className: "incidental-charge-header"
                    }, "Incidental Charges"), React.createElement("p", {
                      className: "icidental-charge-header-action-wrapper",
                      onClick: Curry._1(deleteClickHandler, id)
                    }, React.createElement("img", {
                          className: "incidental-charge-remove-icon",
                          src: deleteIcon
                        }), React.createElement("label", {
                          className: "icidental-charge-header-action-label"
                        }, "Remove"))), React.createElement("div", {
                  className: "incidental-charge-card-body"
                }, React.createElement("div", {
                      className: "incidental-charge-card-items"
                    }, React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, React.createElement("label", undefined, "Type"), React.createElement("label", {
                                        className: "adjust-fare-mendatory-field-sign"
                                      }, "*")), React.createElement(FormTextInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                            
                                          }), true, undefined, "", undefined, undefined, undefined, undefined, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    textinput_props: {
                                      value: incident_type
                                    }
                                  }))
                        })), React.createElement("div", {
                      className: "incidental-charge-card-items"
                    }, React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, React.createElement("label", undefined, "Amount (" + currency_symbol + ")"), React.createElement("label", {
                                        className: "adjust-fare-mendatory-field-sign"
                                      }, "*")), React.createElement(FormTextInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                            
                                          }), true, undefined, "", undefined, undefined, undefined, undefined, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    textinput_props: {
                                      value: amount.toFixed(2)
                                    }
                                  }))
                        }))));
}

var Card = {
  make: ViewIncidentalCharges$Card
};

function ViewIncidentalCharges(Props) {
  var currency_symbol = Props.currency_symbol;
  var incidental_charges = Props.incidental_charges;
  var dispatch = Props.dispatch;
  var updateIncidentalCharges = Props.updateIncidentalCharges;
  var deleteClickHandler = function (id, _event) {
    var updated_incidental_charge_list = List.filter(function (incident) {
            return id !== incident.charge_type.id;
          })(incidental_charges);
    Curry._1(updateIncidentalCharges, (function (param) {
            return updated_incidental_charge_list;
          }));
    return Curry._1(dispatch, {
                TAG: /* UpdatePreviewButtonStatus */6,
                is_preview_fare_button_enabled: true
              });
  };
  var getAddedIncidentalCharge = function (param) {
    return Belt_List.toArray(List.map((function (incident) {
                      return React.createElement(ViewIncidentalCharges$Card, {
                                  currency_symbol: currency_symbol,
                                  incident_type: incident.charge_type.name,
                                  amount: Currency.fromCurrency(incident.amount),
                                  id: incident.charge_type.id,
                                  deleteClickHandler: deleteClickHandler
                                });
                    }), incidental_charges));
  };
  return React.createElement("div", {
              className: "c-existing-incidental-charge"
            }, getAddedIncidentalCharge(undefined));
}

var make = ViewIncidentalCharges;

export {
  deleteIcon ,
  Card ,
  make ,
  
}
/* deleteIcon Not a pure module */
